<template>
    <v-container class="py-4" v-if="permissions('accessLives')">
        <!-- Header -->
        <v-toolbar dark flat class="mb-0 mt-0 px-6">
            <v-toolbar-title>Lives</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- Filtros -->
            <!--v-btn light class="ml-6" @click="openSearch=!openSearch">
                <v-icon class="mx-2">mdi-magnify</v-icon>
                Buscar
            </v-btn-->
            <!-- Crear -->
            <v-dialog v-model="createDialog" max-width="700px" v-if="permissions('createLives')">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn light v-bind="attrs" v-on="on" class="ml-8">
                        <v-icon class="mx-2">mdi-account-plus</v-icon>
                        Crear
                    </v-btn> 
                </template>
                <create @closeCreateDialog="closeCreateDialog"/>
            </v-dialog>
        </v-toolbar>
        <!-- Search bar -->
        <v-text-field v-show="openSearch" class="px-12 pt-6" append-icon="mdi-magnify" style="background:white;" @keydown.enter="buscar = !buscar" dense outlined v-model="search" placeholder="Buscador"></v-text-field>

        <!-- Loader -->
        <v-progress-linear v-if="loading" color="primary" class="mt-4" indeterminate rounded height="6"></v-progress-linear>

        <!-- Container -->
        <v-container v-else class="pa-0">
            <!-- Lives -->
            <v-row dense class="ma-0 pa-4" style="background:white;">
                <v-col v-for="(live, index) in records" v-bind:key="index" cols="4" class="pa-4">
                    <v-dialog v-model="live.dialog" width="500">
                        <template v-slot:activator="{ on, attrs }">
                            <v-card  v-bind="attrs" v-on="on">
                                <v-card-title class="pb-0">
                                    {{live.name}}
                                    <v-spacer/>
                                    <v-switch :disabled="live.is_active" @click.stop="change_status(live.id)" v-model="live.is_active" inset></v-switch>
                                </v-card-title>
                                <v-row class="mb-0 pb-2">
                                    <v-spacer/>
                                    <v-btn @click.stop="deleteItem(live.id)" text x-small>Eliminar</v-btn>
                                    <v-spacer/>
                                </v-row>
                            </v-card>
                        </template>
                        <v-card v-if="live.dialog">
                            <div style="min-height:50vh; background:white;" class="htmlcontent" v-html="live.embedded_code" :wrap_code="true"></div>
                        </v-card>
                    </v-dialog>

                </v-col>
            </v-row>
            <!-- Pagination -->
            <div class="text-center mt-4">
                <v-pagination
                circle
                v-model="page"
                :length="pageRecords"
                :total-visible="6"
                ></v-pagination>
            </div>
        </v-container>
        <!-- Editar -->
        <v-dialog v-model="editDialog" max-width="700px">
          <edit v-bind:live="record" @closeEditDialog="closeEditDialog"/>
        </v-dialog>
        <!-- Eliminar -->
        <div class="text-center">
            <v-bottom-sheet  v-model="sheet" inset>
                <v-sheet class="text-center" height="150px">
                    <div class="pt-6">
                    ¿Seguro que deseas borrar este Live?
                    </div>
                    <v-btn class="mt-4" text color="error" @click="deleteRecord()">
                    Eliminar
                    </v-btn>
                    <v-btn class="mt-4" text color="grey" @click="cancel()">
                    Cancelar
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>
        <!-- errores -->
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-container>
    <denied-access v-else/>
</template>

<script>
import permissions from '../../mixins/permissions'
import DeniedAccess from '../denied-access.vue';
import axios from "axios";
import Create from "../lives/create"
import Edit from "../lives/edit"
export default {
    mixins: [permissions],
    components: {
        'create':Create,
        'edit':Edit,
        'denied-access':DeniedAccess,
    }, 
    data: () => ({
        dialog:false,
        search:'',
        buscar:false,
        openSearch:false,
        record:{},
        loading: true,
        options: {},
        sheet: false,
        editDialog: false,
        createDialog: false,
        deleteId:'',
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        page:1,
    }),
    created(){
        this.getDataFromApi()
    },
    computed:{
        liga(){
            return process.env.VUE_APP_BACKEND_ROUTE
        },
        pageRecords(){
            return this.$store.state.live.lives_page
        },
        records(){
            return this.$store.state.live.lives
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user
            }
        },
    },
    watch: {
        page: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },
        buscar: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },

    },
    methods:{
        change_status(id){
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/live/set_active?id='+id).then(response=>{
                this.getDataFromApi()
                this.snackbar = {
                    message: 'Cambio realizado con éxito',
                    color: 'success',
                    show: true
                }
            }).catch(error => {
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
            });
        },
        getDataFromApi () {
            this.loading = true
            this.$store.dispatch('live/getLives', {page:this.page}).then(data => {
                this.loading = false
            })
        },
        closeEditDialog: function(params) {
            this.editDialog = params;
            this.getDataFromApi()
        },
        closeCreateDialog: function(params) {
            this.createDialog = params;
            this.getDataFromApi()
        },
        deleteRecord(){
            axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/live/"+this.deleteId).then(response => {
                this.deleteId = ''
                this.sheet = false
                this.getDataFromApi()
            }).catch(error => {
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
            });
        },
        cancel(){
            this.deleteId = ''
            this.sheet = false
        },
        deleteItem (id) {
            this.deleteId = id
            this.sheet = true
        },
        editItem(editedItem){
            this.record = editedItem
            this.editDialog = true
        },
    },
}
</script>